<template>
    <div class="subscription--inner">
        <div class="subscription--inner-wrap" v-if="data">
            <h3>{{ data.title }}</h3>
            
            <div class="button-grid" v-if="data.buttons && data.buttons.length">
                <div
                    class="button-element"
                    v-for="(button, index) in data.buttons"
                    :key="index">
                    <a 
                        v-if="button.button_type === 'button_target'"
                        :href="prettyAnchor(button.button_anchor)"
                        class="button--std">
                        <div>
                            {{ button.button_title }}
                            <span v-if="button.button_subtitle">({{ button.button_subtitle }})</span>
                        </div>
                    </a>
                    <a
                        v-else
                        :href="button.button_link.url"
                        :target="button.button_link.target"
                        class="button--std">
                        <div>
                            {{ button.button_title }}
                            <span v-if="button.button_subtitle">({{ button.button_subtitle }})</span>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'SubscriptionScreenButtons',

    props: {
        data: Object
    },

    methods: {
        prettyAnchor (target) {
            return `#${target}`
        }
    }
}
</script>